import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as _ from 'lodash';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import HistoryIcon from '@material-ui/icons/History';
import InfoModal from '../../packages/AppModal/Info';
import { getLeadFollowups } from '../../modules/Leads/actions';
import FollowupHistoryTable from './FollowupHistoryTable';

export function LeadsFollowupHistory(props) {
  const {
    width,
    row: { lead_id, followup_status, followup_status_label },
  } = props;

  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [followups, setFollowups] = useState([]);

  const handleOpen = () => {
    dispatch(getLeadFollowups(lead_id)).then((resp) => {
      setFollowups(resp?.data || []);
      setIsOpen(true);
    });
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <TableCell
      align="left"
      size="small"
      style={{
        width,
      }}
    >
      {followup_status_label}
      {!_.isEmpty(followup_status) && (
        <IconButton size="small" color="secondary" onClick={handleOpen}>
          <HistoryIcon />
        </IconButton>
      )}
      <InfoModal
        title="Followup History"
        isOpen={isOpen}
        onClose={handleClose}
        maxWidth="md"
      >
        <FollowupHistoryTable followups={followups} />
      </InfoModal>
    </TableCell>
  );
}
